export const CRM_TOKEN_KEY = 'app_builder.crm_token';
export const COMPANY_ID_KEY = 'app_builder.company_id';
// Keys earlier versions wrote; still removed on sign-out so old browsers do not keep them.
const LEGACY_KEYS = ['app_builder.role', 'flavor_admin_token', 'session_id'];

// Tokens within this window of `exp` count as expired, so a request never leaves with a token
// that dies in flight.
const EXPIRY_SKEW_MS = 30 * 1000;

export function getCrmToken() {
  return window.localStorage.getItem(CRM_TOKEN_KEY);
}

export function getCompanyId() {
  return window.localStorage.getItem(COMPANY_ID_KEY);
}

export function decodeJwtPayload(token) {
  const payload = (token || '').split('.')[1] || '';
  const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
  return JSON.parse(window.atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, '=')));
}

// Milliseconds since epoch, or null when the token is opaque or has no numeric `exp`.
export function getTokenExpiry(token = getCrmToken()) {
  if (!token) return null;
  try {
    const { exp } = decodeJwtPayload(token);
    return typeof exp === 'number' ? exp * 1000 : null;
  } catch (error) {
    return null;
  }
}

export function isTokenExpired(token = getCrmToken()) {
  const expiry = getTokenExpiry(token);
  return expiry !== null && expiry - EXPIRY_SKEW_MS <= Date.now();
}

// Time left until isTokenExpired turns true, or null when the token never expires on its own.
export function getMsUntilExpired(token = getCrmToken()) {
  const expiry = getTokenExpiry(token);
  return expiry === null ? null : Math.max(expiry - EXPIRY_SKEW_MS - Date.now(), 0);
}

export function setExternalAccess(token, companyId) {
  if (token) window.localStorage.setItem(CRM_TOKEN_KEY, token);
  if (companyId) window.localStorage.setItem(COMPANY_ID_KEY, companyId);
}

export function hasExternalAccess() {
  const token = getCrmToken();
  return Boolean(token) && !isTokenExpired(token);
}

export function clearExternalAccess() {
  [CRM_TOKEN_KEY, COMPANY_ID_KEY, ...LEGACY_KEYS].forEach((key) => window.localStorage.removeItem(key));
}
